
<table class="featureInfoTable">
@for (fi of mapService.featureInfoArray; track $index) {
    <tr class="featureInfoTR">
    <td class="featureInfoTitleTD">{{fi.title}}</td>
    @for (v of fi.values; track $index) {
        <td class="featureInfoValueTD">{{v}}</td>
    }
    </tr>
}
</table>
<div class="featureInfoChart">
    <app-featureinfochart></app-featureinfochart>
</div>